<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rect: null,
        };
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onScroll);

        this.onScroll();
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    },

    methods: {
        onScroll() {
            this.rect = this.$el.getBoundingClientRect();
        },
    },
};
</script>
